
const ProjectBlob = (props) => {
    
    var local = new Date(props.project.due_date);
    var offset = local.getTimezoneOffset();
    var due_date = new Date(local.getTime() + offset * 60000);

    function convertCurrencyToDouble(currency, locale = 'en-US', currencyType = 'USD') {
        // Creating a NumberFormat object with specified locale and currency
        const formatter = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currencyType,
            currencyDisplay: 'symbol'
        });
    
        // Formatting the currency to remove any non-numeric characters except for decimal point
        const normalizedCurrency = currency.replace(/[^\d.-]+/g, "");
    
        // Converting the normalized string to a double value using Number constructor
        const doubleValue = Number(normalizedCurrency);
    
        // Returning the double value
        return doubleValue;

    }

    const fee = convertCurrencyToDouble(props.project.fee)
    const paid = convertCurrencyToDouble(props.project.paid)

    const statusColorMap = {
        "Not Started":        "#DC0000",
        "Awaiting Assets":    "#FF3300",
        "In Progress":        "#ff7700",
        "Awaiting Feedback":  "#ffb200",
        "Revising":           "#ffee00",
        "Mastering":          "#B2DF00",
        "Delivering":         "#46C408",
        "Complete":           "#00a116",
    };
    const accentColor = statusColorMap[props.project.status] || "#444";

    let statusColor = (function () {
        switch (props.project.status){
            case "Not Started":       return "not_started";
            case "Awaiting Assets":   return "assets";
            case "In Progress":       return "wip";
            case "Awaiting Feedback": return "feedback";
            case "Revising":          return "revising";
            case "Mastering":         return "mastering";
            case "Delivering":        return "delivering";
            case "Complete":          return "complete";
            default:                  return "";
        }
    })();

    return (
        // <div className="projectBlob">
        //     <div className="blobLeft">
        //         <span>
        //             {props.project.client}
        //         </span>
        //         <h4 className="text-black">
        //             {props.project.title}
        //         </h4>
        //     </div>
        //     <div className="blobRight">
        //         <div className={statusColor+ " alignRight"} id="status">
        //             {props.project.status}
        //         </div>
        //         <div className="alignRight" id="due_date">
        //             Due: {due_date.toDateString()}
        //         </div>
        //         <div className="alignRight" id="blobPaid">
        //             {((paid>=fee) )? "Paid" : ""}
        //         </div>
        //     </div>
        // </div>

        <div className="projectBlob" style={{ borderLeft: `3px solid ${accentColor}` }}>
            <div className="blobTop">
                <div className="blobTitle">
                    <span>
                        {props.project.client}
                    </span>
                    <h4 style={{ color: '#e0e0e0' }}>
                        {props.project.title}
                    </h4>
                </div>
                <div className="alignRight" id="due_date">
                    &nbsp; Due  {due_date.toDateString()}
                </div>
            </div>
            <div className="blobBottom">
                <div className={statusColor + " alignRight"} id="status">
                    {props.project.status}
                </div>
                {paid >= fee ?
                    <div className="alignRight" id="blobPaid">Paid</div>
                : null}
            </div>
        </div>
    )
}

export default ProjectBlob